import './styles.css';
import { AppController } from '@/controllers/AppController';

import { library, dom } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import { fab } from '@fortawesome/free-brands-svg-icons';

library.add(fas, far, fab);
dom.watch();

// Bootstrap applicativo
const app = new AppController();
app.start();

// HMR (Vite) — ricrea il controller in caso di update dei moduli
if (import.meta.hot) {
  import.meta.hot.accept();
}
